export const HOME = {
  emergentLink: "home-emergent-link",
  heroCta: "home-hero-cta-design",
  heroCtaPrimary: "home-hero-cta-design",
  heroShop: "home-hero-cta-shop",
  heroTitle: "home-hero-title",
  categoryCard: (slug) => `home-category-${slug}`,
  productCard: (slug) => `home-product-${slug}`,
};

export const HEADER = {
  brand: "header-brand-logo",
  navShop: "header-nav-shop",
  navCustom: "header-nav-custom",
  navAbout: "header-nav-about",
  searchInput: "header-search-input",
  cart: "header-cart-btn",
  wishlist: "header-wishlist-btn",
  account: "header-account-btn",
  login: "header-login-btn",
  signup: "header-signup-btn",
  admin: "header-admin-btn",
  logout: "header-logout-btn",
};

export const AUTH = {
  emailInput: "auth-email-input",
  passwordInput: "auth-password-input",
  nameInput: "auth-name-input",
  submit: "auth-submit-btn",
  google: "auth-google-btn",
  switchMode: "auth-switch-mode-btn",
};

export const CATALOG = {
  productCard: (slug) => `catalog-product-${slug}`,
  filterCategory: "catalog-filter-category",
  filterSort: "catalog-filter-sort",
  filterCustomizable: "catalog-filter-customizable",
  filterReset: "catalog-filter-reset",
  searchInput: "catalog-search-input",
};

export const PRODUCT = {
  sizeBtn: (s) => `product-size-${s}`,
  colorBtn: (c) => `product-color-${c}`,
  qtyInc: "product-qty-inc",
  qtyDec: "product-qty-dec",
  addToCart: "product-add-to-cart",
  customize: "product-customize-btn",
  addToWishlist: "product-add-to-wishlist",
};

export const STUDIO = {
  canvas: "studio-canvas",
  addText: "studio-add-text",
  addShape: "studio-add-shape",
  uploadImage: "studio-upload-image",
  deleteSelected: "studio-delete-selected",
  saveAndAdd: "studio-save-and-add",
  colorPicker: "studio-color-picker",
  fontSize: "studio-font-size",
};

export const CART = {
  item: (id) => `cart-item-${id}`,
  qtyInc: (id) => `cart-qty-inc-${id}`,
  qtyDec: (id) => `cart-qty-dec-${id}`,
  remove: (id) => `cart-remove-${id}`,
  checkout: "cart-checkout-btn",
};

export const CHECKOUT = {
  nameInput: "checkout-name-input",
  phoneInput: "checkout-phone-input",
  line1Input: "checkout-line1-input",
  cityInput: "checkout-city-input",
  stateInput: "checkout-state-input",
  pincodeInput: "checkout-pincode-input",
  placeOrder: "checkout-place-order",
};

export const ADMIN = {
  navDash: "admin-nav-dashboard",
  navProducts: "admin-nav-products",
  navCategories: "admin-nav-categories",
  navCollections: "admin-nav-collections",
  navOrders: "admin-nav-orders",
  newProduct: "admin-new-product-btn",
  newCategory: "admin-new-category-btn",
  newCollection: "admin-new-collection-btn",
  saveBtn: "admin-save-btn",
};
